export default __webpack_public_path__ + "static/media/Wristwraps of the Doomsayer.f0c53dc5.jpg";